import { LogoParksAndUnivers } from '../../../Files/LogoParksAndUnivers.js';

export const BlockLogoParksAndUnivers = (props) => {
    const label = props.label;
    const item = props.item;
    let values;
    if (label === 'park') {
        values = {
            name: item.pname,
            route: item.proute,
            src: LogoParksAndUnivers('park', item.pslug),
        };
    }
    if (label === 'univers') {
        values = {
            name: item.uname,
            route: item.uroute,
            src: LogoParksAndUnivers('univers', item.uslug),
        };
    }
    return (
        <div className="logo">
            <a className="icon" href={values.route} alt={values.name} title={values.name}>
                <img className="img" src={values.src} title={values.name} alt={values.name} loading="lazy" />
            </a>
            <div className="legend">
                <div className="title">{values.name}</div>
            </div>
        </div>
    )
}